import { createElement, useCallback, useEffect } from "react";
import toast from "react-hot-toast";
import { Trash2 } from "lucide-react";
import { useConfirm } from "@/components/ui/confirm-dialog";
import { toastApiError } from "./apiErrors";

export function useDelete<T>({
  item,
  deleteItem,
  isSuccess,
  isError,
  error,
  successMessage,
}: {
  item: T | any;
  deleteItem: (id: string) => void;
  isSuccess: boolean;
  isError: boolean;
  error: any;
  successMessage: string;
}) {
  const confirm = useConfirm();
  const onDelete = useCallback(async () => {
    const ok = await confirm({
      title: "Êtes-vous sûr de vouloir effectuer cette action ?",
      confirmText: "Supprimer",
      cancelText: "Annuler",
      variant: "destructive",
      icon: createElement(Trash2, { className: "h-6 w-6" }),
    });
    if (ok) {
      deleteItem(item?.id);
    }
  }, [confirm, deleteItem, item?.id]);
  useEffect(() => {
    if (isSuccess) {
      toast.success(`${successMessage} avec succès`);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      toastApiError(error, "La suppression a échoué. Veuillez réessayer.");
    }
  }, [isError]);

  return onDelete;
}
